// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__XKDux","nav":"Slider_nav__qcfaT","prev":"Slider_prev__cltav","next":"Slider_next__lyzNk","slide":"Slider_slide__UQfte"};